import { createStore } from 'vuex';

export default createStore({
  state: {
    showMenu: false
  },
  getters: {},
  mutations: {
  },
  actions: {
  },
  modules: {}
});
